import React, { useCallback } from "react";

import { CustomMenuItemProps } from "ag-grid-react";
import { useGridMenuItem } from "ag-grid-react";
import ProcessusLink from "composants/processus/ProcessusLink";
import { ProcessusDefinition } from "types/Processus";
import { ProcessusProvider } from "composants/processus/ProcessusProvider";
import { Pojo } from "types/Galaxy";

export interface ShowConfirmModalProps {
  id: string;
  show: boolean;
  position: { x: number; y: number } | null;
  launchProcess: (editionType?: "rapide" | "apercu" | undefined, forcedSelected?: Pojo[]) => void;
  close: () => void;
  buttonRef: React.RefObject<HTMLDivElement | null>;
  selected?: Pojo[];
}

export interface ButtonCustomMenuItemProps extends CustomMenuItemProps {
  buttonValue: string;
  definition: ProcessusDefinition;
  selected: Pojo;
  sjmoCode: string;
  tableName: string;
  setShowConfirmModal?: (modal: ShowConfirmModalProps) => void;
}

export default function MenuItem({
  subMenu,
  definition,
  selected,
  sjmoCode,
  tableName,
  setShowConfirmModal
}: ButtonCustomMenuItemProps) {
  useGridMenuItem({
    configureDefaults: () => true
  });

  const setShowConfirmModalWithSelected = useCallback(
    (modal: {
      id: string;
      show: boolean;
      position: { x: number; y: number } | null;
      launchProcess: () => void;
      close: () => void;
      buttonRef: React.RefObject<HTMLDivElement | null>;
    }) => {
      setShowConfirmModal && setShowConfirmModal({ ...modal, selected: [selected] });
    },
    [selected, setShowConfirmModal]
  );

  return (
    <div>
      <span className="ag-menu-option-part ag-menu-option-icon" role="presentation"></span>
      <span className="ag-menu-option-part ag-menu-option-shortcut">
        <ProcessusProvider sjmoCode={sjmoCode} tableName={tableName} selected={selected}>
          <ProcessusLink
            key={definition.id}
            definition={definition}
            canDelayProcess
            setShowConfirmModal={setShowConfirmModalWithSelected}
          />
        </ProcessusProvider>
      </span>
      <span className="ag-menu-option-part ag-menu-option-popup-pointer">
        {subMenu && (
          <span
            className="ag-icon ag-icon-small-right"
            unselectable="on"
            role="presentation"
          ></span>
        )}
      </span>
    </div>
  );
}
